import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';

import { SharedAuthFacade } from '@lockton-apps/shared/data-access/auth';
import { CoreFacade } from '@lockton-apps/shared/data-access/core';
import {
  FeedbackService,
  RlaGuards,
  UiModule,
} from '@lockton-apps/shared/ui/lui';
import {
  bottomBar,
  BottomBarService,
} from '@lockton-apps/shared/util/bottom-bar';
import { LAYOUT_CONFIG, LayoutConfig } from '../layout-config';

@Component({
  selector: 'lib-layout',
  imports: [
    CommonModule,
    UiModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    LetDirective,
    PortalModule,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [bottomBar],
})
export class LayoutComponent {
  isAuthenticated$ = this.authFacade.isAuthenticated$;

  menuLinks$ = this.coreFacade.primaryNav$;

  userMenu$ = this.coreFacade.userMenu$;

  footerLinks$ = this.coreFacade.footerNav$;

  loading$ = this.feedbackService.loadingOverlay$;

  rlaGuards = RlaGuards;

  copyright: string;

  constructor(
    private authFacade: SharedAuthFacade,
    private coreFacade: CoreFacade,
    private feedbackService: FeedbackService,
    @Inject(LAYOUT_CONFIG) public data: LayoutConfig,
    public bottomBarService: BottomBarService
  ) {
    this.copyright = data?.copyright || 'Lockton Companies LLP E&OE';
  }
}
